import { useEffect, useState } from "react";
import { X, Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Loading } from "./common";
import { Button } from "./ui/button";

const months = () => Array.from({ length: 12 }, (_, i) => { const d = new Date(); d.setUTCDate(1); d.setUTCMonth(d.getUTCMonth() - i); return d.toISOString().slice(0, 7); });

export function PayoutStatement({ onClose }) {
  const [month, setMonth] = useState(months()[0]);
  const [st, setSt] = useState(null);
  useEffect(() => { setSt(null); api.get("/virtucity/payouts/statement", { params: { month } }).then(({ data }) => setSt(data)).catch(() => setSt({ rows: [], totals_by_kind: {}, total_vc: 0 })); }, [month]);
  const csv = async () => {
    try {
      const { data } = await api.get("/virtucity/payouts/statement.csv", { params: { month }, responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(data); a.download = `virtucity-statement-${month}.csv`; a.click();
    } catch { toast.error("Download failed"); }
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="surface rounded-2xl p-5 w-full max-w-lg max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="vc-statement-modal">
        <div className="flex justify-between items-center mb-4"><div className="font-display font-semibold text-lg">Monthly payout statement</div><button onClick={onClose} data-testid="vc-statement-close"><X size={18} /></button></div>
        <div className="flex gap-2 mb-4">
          <select value={month} onChange={(e) => setMonth(e.target.value)} className="surface-2 border border-white/10 rounded-xl px-3 h-10 text-sm flex-1" data-testid="vc-statement-month">{months().map((m) => <option key={m}>{m}</option>)}</select>
          <Button onClick={csv} variant="outline" className="rounded-full border-white/15 h-10" data-testid="vc-statement-csv"><Download size={14} className="mr-1.5" />CSV</Button>
        </div>
        {!st ? <Loading /> : <>
          <div className="grid grid-cols-2 gap-2 mb-4">
            <div className="surface-2 rounded-xl p-3"><div className="text-[11px] text-muted-foreground">Total</div><div className="font-display font-bold text-xl text-gold" data-testid="vc-statement-total">{st.total_vc} VC</div></div>
            <div className="surface-2 rounded-xl p-3 text-xs space-y-0.5">{Object.entries(st.totals_by_kind).length ? Object.entries(st.totals_by_kind).map(([k, v]) => <div key={k} className="flex justify-between capitalize"><span>{k}</span><span>{v} VC</span></div>) : <span className="text-muted-foreground">No payouts</span>}</div>
          </div>
          {st.rows.map((r, i) => (
            <div key={i} className="flex justify-between text-xs py-2 border-b border-white/5 last:border-0" data-testid={`vc-statement-row-${i}`}>
              <div className="min-w-0"><div className="capitalize font-medium">{r.kind}</div><div className="text-muted-foreground truncate">{new Date(r.date).toLocaleDateString()} · {r.description}{r.city_amount ? ` · $${Number(r.city_amount).toLocaleString()} city` : ""}</div></div>
              <span className="text-emerald-400 shrink-0 ml-2">+{r.vc} VC</span>
            </div>
          ))}
        </>}
      </div>
    </div>
  );
}
